/** @prettier */

/**
 * 登録数超過時の表示
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {PrimaryButton} from './BasicButton';

/**
 * 登録数超過時の表示
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - title タイトル
 * - text メッセージ
 */
const NoMoreRegister = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  text: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  //OKボタン押下時処理
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText>{props.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans('NoMoreRegister.errDialog.buttonTxt.ok')}
        />
      </DialogActions>
    </Dialog>
  );
};
export default NoMoreRegister;
